import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref } from 'vue';
import { useRoomStore } from '../../stores/room';
import { storeToRefs } from 'pinia';
import TuiSelect from './base/Select.vue';
import TuiOption from './base/Option.vue';

import useGetRoomEngine from '../../hooks/useRoomEngine';
import { TRTCDeviceInfo } from '@tencentcloud/tuiroom-engine-js';
interface Props {
  deviceType: string,
  onChange?: (id: string) => void,
  disabled?: Boolean
}
// eslint-disable-next-line vue/no-setup-props-destructure

export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceSelect',
  props: {
    deviceType: null,
    onChange: null,
    disabled: null
  },
  setup(__props: any) {

const { deviceType, onChange, disabled = false } = __props as {
  deviceType: string,
  onChange?: (id: string) => void,
  disabled?: Boolean
}

const roomEngine = useGetRoomEngine();



const roomStore = useRoomStore();
const {
  cameraList,
  microphoneList,
  speakerList,
  currentCameraId,
  currentMicrophoneId,
  currentSpeakerId,
} = storeToRefs(roomStore);

// @ts-ignore
const deviceList: Ref<TRTCDeviceInfo[]> = ref(getDeviceList());
const currentDeviceId = ref(getInitDeviceId());

function getInitDeviceId() {
  if (deviceType === 'camera') {
    return currentCameraId;
  }
  if (deviceType === 'microphone') {
    return currentMicrophoneId;
  }
  if (deviceType === 'speaker') {
    return currentSpeakerId;
  }
  return '';
}

function getDeviceList() {
  if (deviceType === 'camera') {
    return cameraList;
  }
  if (deviceType === 'microphone') {
    return microphoneList;
  }
  if (deviceType === 'speaker') {
    return speakerList;
  }
  return [];
}

async function handleChange(deviceId: string) {
  onChange && onChange(deviceId);
  switch (deviceType) {
    case 'camera':
      await roomEngine.instance?.setCurrentCameraDevice({ deviceId });
      roomStore.setCurrentCameraId(deviceId);
      break;
    case 'microphone':
      await roomEngine.instance?.setCurrentMicDevice({ deviceId });
      roomStore.setCurrentMicrophoneId(deviceId);
      break;
    case 'speaker':
      await roomEngine.instance?.setCurrentSpeakerDevice({ deviceId });
      roomStore.setCurrentSpeakerId(deviceId);
      break;
    default:
      break;
  }
}

return { __sfc: true,roomEngine, roomStore, cameraList, microphoneList, speakerList, currentCameraId, currentMicrophoneId, currentSpeakerId, deviceList, currentDeviceId, getInitDeviceId, getDeviceList, handleChange, TuiSelect, TuiOption }
}

})